<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head">
        <div class="head-info">
          <el-row>
            <el-col style="text-align: left" :span="24">
              <el-page-header
                style="color: #333333"
                :title="$t('commonInfo.Back')"
                @back="goBack"
                content="修改资料"
              ></el-page-header>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <el-main>
        <el-form class="edit-form" :model="user_info" label-width="80px">
          <el-form-item label="昵称:" prop="name">
            <el-input
              v-model="user_info.nick_name"
              placeholder="请输入昵称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item style="text-align: left" label="头像:">
            <el-input v-model="user_info.avatar" clearable></el-input>
            <el-row>
              <el-col :span="6">
                <el-image
                  style="width: 100px; height: 100px; margin-top: 10px"
                  :src="user_info.avatar + $common.K_QINIU_IMAGE_SMALL_END_200"
                  :preview-src-list="[user_info.avatar]"
                  lazy
                ></el-image>
              </el-col>
              <el-col :span="18">
                <dl>
                  <dt class="edit-row-dt">
                    <el-button size="mini" type="primary" @click="">
                      本地上传
                    </el-button>
                  </dt>
                  <dt class="edit-row-dt">
                    <el-button
                      size="mini"
                      type="warning"
                      @click="getImageByWeb()"
                    >
                      资源选择
                    </el-button>
                  </dt>
                </dl>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              style="width: 100px"
              @click="saveNewPassword"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
    <FileChooseDrawerModule ref="UpdateUserInfoViewFileChooseDrawerModule" />
  </div>
</template>

<script>
import FileChooseDrawerModule from "../file/module/FileChooseDrawerModule";

export default {
  name: "UpdateUserInfoView",
  components: {
    FileChooseDrawerModule,
  },
  data() {
    return {
      loading: false,
      userModel: {},
      user_info: {
        nick_name: "",
        user_id: "",
        avatar: "",
      },
    };
  },
  created() {
    // 获取用户信息
    let userJson = sessionStorage.getItem("_user");
    if (userJson != null && userJson.length > 0) {
      this.userModel = JSON.parse(userJson);
      this.user_info.nick_name = this.userModel.nick_name;
      this.user_info.user_id = this.userModel.user_id;
      this.user_info.avatar = this.userModel.avatar;
    } else {
      this.$message.error("用户信息获取失败");
      this.goBack();
    }
  },
  methods: {
    saveNewPassword() {
      let _me = this;
      let params = this.user_info;
      this.$common
        .httpPost("/api/user/update/info", params)
        .then((res) => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success("信息修改成功");
            // 更新存储的信息
            _me.$common.setToken(res.data.token);
            sessionStorage.setItem("_token", res.data.token);
            _me.userModel.avatar = res.data.avatar;
            _me.userModel.nick_name = res.data.nick_name;
            sessionStorage.setItem("_user", JSON.stringify(_me.userModel));
            _me.goBack();
          } else {
            _me.$message.error(res.message);
          }
        })
        .catch((err) => {
          _me.loading = false;
          _me.$message.error(err);
        });
    },
    getImageByWeb() {
      let _me = this;
      this.$refs.UpdateUserInfoViewFileChooseDrawerModule.showChooseDrawer(
        function (chooseFileList) {
          console.log("接收到选择的文件:", chooseFileList);
          if (chooseFileList.length > 0) {
            _me.user_info.avatar = chooseFileList[0].file_url;
          }
        }
      );
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.banner-head {
  /*background-color: white;*/
  background-color: #f1f1f1;
  height: 60px;
}

.head-info {
  color: #ffffff;
}

.edit-form {
  margin: 20px 10px 10px 0;
  text-align: left;
  min-width: 600px;
  max-width: 600px;
}
</style>